import { createFileRoute } from '@tanstack/react-router';
import { ManualShipment } from '@uturn/portal/modules/shipments';

export const Route = createFileRoute('/_protected/shipments/add/manual')({
	component: ManualShipment,
});
